//
import Model from '@/models/Model'

//
import ConfirmModel from '@/models/Confirm'

export default class HrSalarySettlement extends Model {
    /**
     *
     */
    static includes = [
        'hr_employee',
        'hr_contract.hr_contract_type',
        'hr_contract.hr_contract_period',
        'hr_asset_discounts',
    ]

    /**
     *
     */
    get base_salary_calculated() {
        return (this.hr_contract_base_salary * this.worked_days) / 30
    }

    /**
     *
     */
    get base_salary_proportional_calculated() {
        return Number(this.base_salary_calculated || 0).toFixed(0)
    }

    /**
     *
     */
    get can_edit() {
        return !this.confirmed
    }

    /**
     *
     */
    get hr_contract_base_salary() {
        return this.hr_contract ? this.hr_contract.base_salary : 0
    }

    /**
     *
     */
    get hr_contract_type_name() {
        return this.hr_contract
            ? this.hr_contract.hr_contract_type.name
            : 'Sin contrato'
    }

    /**
     *
     */
    get hr_contract_weekly_hours() {
        return this.hr_contract ? this.hr_contract.weekly_hours : 0
    }

    /**
     *
     */
    get hr_employee_rut() {
        return this.hr_employee ? this.hr_employee.rut : null
    }

    /**
     *
     */
    get period_month_parsed() {
        return this.period_month < 10
            ? '0' + this.period_month
            : this.period_month
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get period_case() {
        return `${this.period_year}-${this.period_month_parsed}`
    }

    /**
     *
     */
    confirm() {
        return this.hasMany(ConfirmModel)
    }

    /**
     *
     */
    mapDetail = item => ({
        amount: Number(item.amount),
        hr_asset_discount_id: Number(item.id),
    })

    /**
     *
     */
    mapSelected = item => ({
        amount: Number(item.pivot.amount),
        id: Number(item.id),
        name: String(item.name),
    })

    /**
     *
     */
    reset() {
        //
        this.period = this.period_year + '-' + this.period_month_parsed
        this.selected = this.hr_asset_discounts.map(this.mapSelected)
        //
        this.discount_hh_hours = Math.floor(this.discount_hh)
        this.discount_hh_minutes = Math.round(Number(this.discount_hh%1)*60)
        this.extra_hh_hours = Math.floor(this.extra_hh)
        this.extra_hh_minutes = Math.round(Number(this.extra_hh%1)*60)
        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'hr_salary_settlement'
    }

    /**
     *
     */
    toCreate() {
        
        //
        this.period_month = Number(this.period.split('-').pop())
        this.period_year = Number(this.period.split('-').shift())

        //
        this.discount_hh = Number(this.discount_hh_hours) + Number((this.extra_hh_minutes/60).toFixed(3))
        this.extra_hh = Number(this.extra_hh_hours) + Number((this.extra_hh_minutes/60).toFixed(3))

        //
        return this.clean([
            'acc_cost_center_id',
            'advance',
            'apv',
            'apv_afp',
            'bonuses',
            'discount_hh',
            'extra_hh',
            'hr_salary_settlement_asset_discount',
            'hr_employee_id',
            'loan_ccaf_quote_amount',
            'period_month',
            'period_year',
            'unique_tax_amount',
            'worked_days',
        ])
    }

    /**
     *
     */
    toUpdate() {

        //
        this.period_month = Number(this.period.split('-').pop())
        this.period_year = Number(this.period.split('-').shift())

        //
        this.discount_hh = Number(this.discount_hh_hours) + Number((this.discount_hh_minutes/60).toFixed(3))
        this.extra_hh = Number(this.extra_hh_hours) + Number((this.extra_hh_minutes/60).toFixed(3))

        //
        this.hr_salary_settlement_asset_discount = this.selected.map(
            this.mapDetail
        )

        //
        return this.clean([
            'acc_cost_center_id',
            'advance',
            'apv',
            'apv_afp',
            'bonuses',
            'discount_hh',
            'extra_hh',
            'hr_employee_id',
            'hr_salary_settlement_asset_discount',
            'id',
            'loan_ccaf_quote_amount',
            'period_month',
            'period_year',
            'unique_tax_amount',
            'worked_days',
        ])
    }
}
